import { useTrans } from "@/translations";

import { twMerge } from "tailwind-merge";

import { ViewWithLoader } from "../ViewWithLoader";

export type KpiNumberData = {
  id: string;
  title: string;
  getValue: () => string | number;
  valueSuffix: string;
  getBottomText: () => React.ReactNode;
  dataNotAvailable?: boolean;
  dataNotAvailableTextKey?: string;
};

type Props = {
  showLoadingView: boolean;
  numbersData: KpiNumberData[];
  gridClassNames?: string;
};

export const KpiNumbersView: React.FC<Props> = ({
  showLoadingView,
  numbersData,
  gridClassNames = "grid-cols-3 lg:grid-cols-6",
}) => {
  const { t } = useTrans();

  return (
    <ViewWithLoader isLoading={showLoadingView} loaderClassName="h-[82px]">
      <div
        className={twMerge(
          "mt-[20px] ml-[20px] grid gap-[26px]",
          gridClassNames,
        )}
      >
        {numbersData.map((d) => (
          <div className="h-[82px] min-w-0" key={d.id}>
            <div className="text-grey6 mb-1.5 text-[clamp(9px,0.7vw,11px)] font-bold tracking-[0.9px] uppercase">
              {t(d.title)}
            </div>
            {d.dataNotAvailable ? (
              <div className="font-signifier mt-[20px] text-[10px] leading-[1.1] leading-[13px] italic">
                {t(d.dataNotAvailableTextKey || "")}
              </div>
            ) : (
              <div className="flex items-baseline">
                <div className="font-signifier text-[clamp(24px,2.5vw,48px)] leading-none">
                  {d.getValue()}
                </div>
                <div className="text-grey6 ml-1.5 text-[clamp(10px,0.95vw,16px)]">
                  {d.valueSuffix}
                </div>
              </div>
            )}
            {d.getBottomText()}
          </div>
        ))}
      </div>
    </ViewWithLoader>
  );
};
